import React from 'react';
import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BackButton } from 'pages/ticketV2/common/style';
import { Roles } from 'utils/constants';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';
import { useTicketsStore } from '../store/ticketsStore';

const Header = ({ backFn, loggedUser, hideBack = false }) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isOperator = loggedUser?.type === Roles.OPERATOR;
  const intl = useIntl();
  const i18n = translations.TicketsV2(intl).Buy;
  const i18nCommon = translations.TicketsV2(intl).Common;
  const { isEditingTicketMode, isAddingCatalogueMode } = useTicketsStore();

  return (
    <Stack
      direction={'row'}
      justifyContent={
        !isEditingTicketMode && !isAddingCatalogueMode
          ? 'space-between'
          : 'flex-end'
      }
      alignItems={'flex-start'}
      gap={'15px'}
      sx={{
        ...(!hideBack && {
          mb: isSmDown ? '30px' : '40px',
        }),
      }}
    >
      {!isEditingTicketMode && !isAddingCatalogueMode ? (
        <>
          {hideBack ? (
            <div>
              <Typography variant="xl" component={'h1'}>
                {i18n.greetings1} {loggedUser.givenName || ''},{' '}
                {i18n.greetings2}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: '5px',
                  mt: isSmDown ? '10px' : '25px',
                }}
                component={'p'}
              >
                {i18n.numberOfTickets}
              </Typography>
            </div>
          ) : (
            <BackButton backFn={backFn} />
          )}
        </>
      ) : null}

      {!isMdDown ? (
        <Stack
          sx={{
            bgcolor: theme.palette.grey[200],
            color: 'black',
            p: '10px 15px',
            borderRadius: '25px',
            minWidth: '162px',
          }}
        >
          <Typography
            variant="s-bold"
            fontFamily={'Suisse-Intl'}
            textAlign="center"
            component={'p'}
          >
            {isOperator ? i18nCommon.operator : i18nCommon.generalPublic}
          </Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};
export default Header;
